export const TransactionDirection = {
  Incoming: 'Incoming',
  Outgoing: 'Outgoing',
} as const;
export type TransactionDirection = (typeof TransactionDirection)[keyof typeof TransactionDirection];
